import { BaseComponent } from '../../components/base-component'
import { CartPage } from './cart'
import { FreeShippingBar } from '../../components/free-shipping-bar/free-shipping-bar'
import { $el, $elParent } from 'src/scripts/utils/utils'

const CART_PAGE_SELECTOR = 'cart-page'
const FREE_SHIPPING_BAR = 'free-shipping-bar'

export class CartFreeShippingBarBlock extends BaseComponent {
  mountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.on('update-nodes', this.handleCartUpdate)
  }

  unmountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.off('update-nodes', this.handleCartUpdate)
  }

  handleCartUpdate = (data: any): void => {
    const bar: FreeShippingBar = $el(FREE_SHIPPING_BAR, this)
    const newBar: FreeShippingBar = $el(FREE_SHIPPING_BAR, data.node)

    if (!bar || !newBar) {
      return
    }

    bar.replaceWith(newBar)
  }
}
